import { AfterViewInit, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Modal } from 'bootstrap';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: 'app-bag-payment-term-list-table',
	templateUrl: './bag-payment-term-list-table.component.html',
	styleUrls: ['./bag-payment-term-list-table.component.scss'],
})
export class BagPaymentTermListTableComponent implements AfterViewInit, OnChanges {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@Input() elements;
	@Input() tableColumns: any[];
	protected tableKeys: string[];
	protected itemsBeforeDataLoad = 0;
	protected tableShowOptions = false;
	protected module = 'paymentTermList';
	protected matData = new MatTableDataSource<any>();

	viewIsSet = false;
	showTable = true;
	showColumns: string[] = [];
	settings = {
		hiddenColumns: [],
	};

	private readonly SNACKBAR_DURATION = 3000;

	constructor(
		private readonly loader: LoaderService,
		private readonly snackBar: MatSnackBar,
	) {}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
		this.paginator._intl.itemsPerPageLabel = 'Pozycji na stronie: ';
		this.paginator._intl.lastPageLabel = 'Ostatnia strona';
		this.paginator._intl.firstPageLabel = 'Pierwsza strona';
		this.paginator._intl.nextPageLabel = 'Następna strona';
		this.paginator._intl.previousPageLabel = 'Poprzednia strona';
	}

	ngOnChanges(): void {
		if (!this.elements && !this.tableColumns) {
			return;
		}
		this.settingsLoad();
		this.loadData();
	}

	protected loadData(): void {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.matData.data = this.elements;
		this.loader.show();
		this.convertData(this.matData.data);
	}

	protected convertData(data) {
		this.tableKeys = this.tableColumns.map((col) => col.id);
		this.tableKeys.push('columnShow');
		this.matData.data = data;
		this.settingsLoad();
		this.generateColumns();
		this.loader.hide();
	}

	protected generateColumns(): void {
		this.showColumns = this.tableKeys.filter((obj) => !this.settings.hiddenColumns.includes(obj));
	}

	protected showHideRow(itemId): void {
		if (!this.settings.hiddenColumns.includes(itemId)) {
			this.settings.hiddenColumns.push(itemId);
		} else {
			this.settings.hiddenColumns.splice(this.settings.hiddenColumns.indexOf(itemId), 1);
		}
		this.settingsSave();
		this.loadData();
		this.viewIsSet = !!(this.settings.hiddenColumns && this.settings.hiddenColumns.length);
		this.loader.hide();
	}

	private settingsSave(): void {
		localStorage.setItem('pageSettings-' + this.module, JSON.stringify(this.settings));
	}

	private settingsLoad(): void {
		if (!localStorage['pageSettings-' + this.module]) {
			return;
		}
		this.settings = JSON.parse(localStorage['pageSettings-' + this.module]);
		this.viewIsSet = !!(this.settings.hiddenColumns && this.settings.hiddenColumns.length);
	}

	copy2Clipboard(): void {
		const col = [
			'term',
			'value',
			'balance',
			'source',
			'status',
			'product',
			'countKind',
			'countValue',
			'reservation',
			'reservationStayTime',
			'reservationOrganization',
			'reservationSeller',
		];
		const rows = this.matData.data.map((row: any) => {
			const obj = {
				term: row.term,
				value: row.valueName,
				balance: row.balanceValueName,
				source: row.source,
				product: row.product,
				status: row.status,
				countKind: row.countKind,
				countValue: row.countValue,
				reservation: row.tableId.label,
				reservationStayTime: row.reservationStayTime,
				reservationOrganization: row.reservationOrganization,
				reservationSeller: row.reservationSeller,
			};

			return Object.assign([], obj, {
				...col.map((header) => obj[header]),
			});
		});
		const table = [col, ...rows];
		const csvData = table.map((row) => row.join(';')).join('\n');
		navigator.clipboard.writeText(csvData);

		this.snackBar.open('Skopiowano do schowka', 'Zamknij', {
			duration: this.SNACKBAR_DURATION,
		});
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	openDialog(): void {
		new Modal(document.getElementById('addModal')).show();
	}
}
